import { createStore, compose } from 'redux';

import createRootReducer from './createRootReducer';

function configureStore(initialState = {}, history) {
  const reducer = createRootReducer(history);

  const composeEnhancers = (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

  const store = createStore(reducer, initialState, composeEnhancers());

  return store;
}

export default configureStore;
